<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> {{ pageName }}
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse1" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="4">
                      <b-form-group>
                        <label class="text-black-50">Quiz Name</label>
                        <div>{{ item.title }}</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <label class="text-black-50">Description</label>
                        <div>{{ item.description }}</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <label class="text-black-50">Each Question Seconds</label>
                        <div>{{ item.seconds }}</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-group>
                        <label class="text-black-50">Total Quiz Time</label>
                        <div>{{ item.totalMinutes }}</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <label class="text-black-50">Points</label>
                        <div>{{ item.points }}</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <label class="text-black-50">End Date</label>
                        <div>{{ dateFormat(item.endDate) }}</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <table class="table table-bordered table-sm">
                        <thead class="thead-light">
                        <tr>
                          <th width="2%" scope="col" class="text-center">#</th>
                          <th width="15%" scope="col">Chat Id</th>
                          <th width="20%" scope="col">Full name</th>
                          <th width="20%" scope="col">Phone</th>
                          <th width="10%" scope="col">Total Points</th>
                          <th width="23%" scope="col">Time</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(winner, index) in item.items" :key="index">
                          <td class="text-center">{{ winner.number }}</td>
                          <td>
                            <span>{{ winner.chatId }}</span>
                          </td>
                          <td>
                            <span>{{ getFullName(winner.firstName, winner.lastName) }}</span>
                          </td>
                          <td>
                            <span>{{ winner.phone }}</span>
                          </td>
                          <td>
                            <span>{{ winner.totalPoint }}</span>
                          </td>
                          <td>
                            <span>{{ winner.totalDuration }}</span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-end">
                    <div class="form-actions">
                      <router-link type="cancel" class="btn btn-secondary" variant="secondary" :to="'/quiz'">Cancel</router-link>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'QuizWinnersSummaryPage',
  data () {
    return {
      item: {}
    }
  },
  created () {
    if (!this.$route.params.id || this.$route.params.id <= 0) {
      return
    }
    this.$loading.show()
    this.axios.get('quiz/winners', {params: {quizId: this.$route.params.id}})
      .then(response => {
        this.item = response.data.data
        this.$loading.hide()
      })
      .catch(error => {
        this.$loading.hide()
        if (error.response && error.response.data.status === 400) {
          this.$toastr.error(error.response.data.message)
        }
      })
  },
  methods: {
    getFullName (firstName, lastName) {
      let fullName = ''
      if (firstName) {
        fullName = firstName
      }
      if (lastName) {
        fullName += ' ' + lastName
      }
      return fullName
    },
    dateFormat (date) {
      return date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  },
  computed: {
    pageName () {
      return 'Quiz winners'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/quiz/QuizWinnersSummaryPage.vue